module.exports = __webpack_public_path__ + "static/img/shawn-ang-nmpW_WwwVSc-unsplash_thumb.02a90f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/shawn-ang-nmpW_WwwVSc-unsplash_thumb.png
// module id = 5pIy
// module chunks = 4